import type { DocumentoExportable, FilaExportable } from "@/componentes/exportar/modelo"

import { type Proceso, TIPOS } from "./tipos"

/**
 * Los procesos de la vista —con el filtro de área puesto— y sus pasos, como documento
 * exportable (29/10). En pantalla son una lista y una ficha; aquí, dos tablas.
 */
const TIPO = new Map<string, string>(TIPOS.map(([v, t]) => [v, t]))

export function documentoDeProcesos(procesos: Proceso[], filtro: string): DocumentoExportable {
  const pasos: FilaExportable[] = []
  for (const p of procesos) {
    if (p.pasos.length === 0) continue
    pasos.push({ celdas: [p.nombre, null, null, null, null], grupo: true })
    for (const s of [...p.pasos].sort((a, b) => a.orden - b.orden)) {
      const ramas = [s.rama_si && `Sí: ${s.rama_si}`, s.rama_no && `No: ${s.rama_no}`]
        .filter(Boolean)
        .join(" · ")
      pasos.push({
        celdas: [s.orden, TIPO.get(s.tipo) ?? s.tipo, s.titulo, s.responsable, ramas || null],
      })
    }
  }
  return {
    titulo: "Procesos",
    subtitulo: filtro,
    secciones: [
      {
        titulo: "Procesos",
        columnas: [
          { titulo: "Proceso", tipo: "texto" },
          { titulo: "Área", tipo: "texto" },
          { titulo: "Responsable", tipo: "texto" },
          { titulo: "Transversal", tipo: "texto" },
          { titulo: "Pasos", tipo: "numero" },
          { titulo: "Procedimiento (PRO)", tipo: "texto" },
          { titulo: "Estado", tipo: "texto" },
        ],
        filas: procesos.map((p) => ({
          celdas: [
            p.nombre,
            p.departamento ?? "Sin área",
            p.responsable,
            p.es_transversal ? "Sí" : "No",
            p.pasos.length,
            p.documento,
            p.activo ? "Activo" : "Inactivo",
          ],
        })),
      },
      ...(pasos.length > 0
        ? [
            {
              titulo: "Pasos de cada proceso",
              columnas: [
                { titulo: "Orden", tipo: "numero" as const },
                { titulo: "Tipo", tipo: "texto" as const },
                { titulo: "Paso", tipo: "texto" as const },
                { titulo: "Responsable", tipo: "texto" as const },
                { titulo: "Ramas", tipo: "texto" as const },
              ],
              filas: pasos,
            },
          ]
        : []),
    ],
  }
}
